// Route: /legal/accept — consent flow.
// Search params: ?returnTo=/onboarding/country, ?demo=allRead|submitting|error
import { tolerantSearch } from "@studyhub/shared/utils/tolerant-search";
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { ConsentFlow } from "@/components/legal/consent-flow";

const searchSchema = z.object({
	returnTo: z.string().optional(),
	demo: z.enum(["default", "allRead", "submitting", "error"]).optional(),
});

export const Route = createFileRoute("/legal/accept")({
	validateSearch: tolerantSearch(searchSchema),
	component: AcceptPage,
});

function AcceptPage(): React.ReactElement {
	const search = Route.useSearch();
	return <ConsentFlow demoMode={search.demo ?? "default"} />;
}
